export const breakpoints = {
  desktop: "@media (min-width: 1360px) ", /*no*/
  tablet: "@media (min-width: 1025px) and (max-width: 1359px)",/*no*/
  phone: "@media (max-width: 1024px)",
  phoneSmallHeight: "@media (max-height: 786px)",

  phoneTablet: "@media (max-width:1255px)",/*no*/
  mobileFirst: "@media (min-width: 975px)",
  smallDesktop: "@media (min-width: 1201px) and (max-width: 1367px)",/*prueba nuevo para reemplazar tablet*/
  BigDesktop: "@media (min-width: 1367px) ", /*prueba nuevo para reemplazar desktop*/
  darkMode: "@media (max-width: 1024px)",

  // los siguiente se importan desde olé para estaditicas
  mobile: "@media (max-width: 600px)",
  smallMobile: "@media (max-width: 450px)",
  maxTablet: "@media (max-width: 1400px)",
  storyDesktopSm: "@media (min-width: 1024px) and (max-width: 1280px)",
  storyTablet: "@media (min-width: 801px) and (max-width: 1023px)",
  storyMobile: "@media (max-width: 800px)",
  mediumDesktop: "@media (min-width: 1400px)",
  desktopSmall: "@media (max-width: 1860px)",
};